/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'

import {Resume} from './components/custom/Resume'
import {TooltipProvider} from './components/ui/tooltip'

import '../styles/globals.css'

const elem = document.getElementById('root')

if (!elem) throw new Error('No root element found')

const app = (
  <StrictMode>
    <TooltipProvider>
      <Resume />
    </TooltipProvider>
  </StrictMode>
)

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  // biome-ignore lint/suspicious/noAssignInExpressions: bun init created this
  const root = (import.meta.hot.data.root ??= createRoot(elem))
  root.render(app)
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app)
}
